<template>
    <div :id="menuId">
        <div
            v-for="(menuItem, i) in menu.menuItems"
            :key="i"
            class="menuMyAccountItem"
        >
            <a
                v-if="isExternal(menuItem, $i18n.locale)"
                :href="menuItem.menuItemURLo[$i18n.locale]"
                class=""
            >
                <fa
                    :icon="[
                        'fal',
                        menuItem.menuItemIcon && menuItem.menuItemIcon.snake
                    ]"
                    class="fa-lg mr-2"
                />
                {{ menuItem.menuItemLabel[$i18n.locale] }}
            </a>
            <nuxt-link
                v-else-if="isInternal(menuItem, $i18n.locale)"
                :to="getCustomLocalePath(menuItem)"
                nuxt
                exact
                class=""
            >
                <fa
                    :icon="[
                        'fal',
                        menuItem.menuItemIcon && menuItem.menuItemIcon.snake
                    ]"
                    class="fa-lg mr-2"
                />
                {{ menuItem.menuItemLabel[$i18n.locale] }}
            </nuxt-link>
        </div>
    </div>
</template>
<script>
import menuUtilities from '~/mixins/menuUtilities.js'
export default {
    name: 'MenuMyAccount',
    mixins: [menuUtilities],
    props: {
        menu: {
            type: Object,
            default: () => ({})
        },
        steez: {
            type: String,
            default: null
        },
        menuId: {
            type: String,
            default: null
        }
    }
}
</script>
<style lang="scss" scoped>
.menuMyAccountItem {
    text-transform: uppercase;
    a {
        display: block;
        padding: 1rem;
        border-color: #e0e0e0;
        border-style: solid;
        border-width: 1px 1px 0 0;
        text-decoration: none;
    }
    a.nuxt-link-active {
        border-right-width: 0;
        color: #ffffff;
        background: $secondary;
    }
    &:last-child a {
        border-bottom-width: 1px;
    }
    &:hover a {
        background: $primary;
        color: #ffffff;
        text-decoration: underline;
    }
    &:hover .svg-inline--fa {
        color: #ffffff;
    }
    .nuxt-link-active & {
        color: #ffffff;
    }
}
.svg-inline--fa {
    .nuxt-link-active & {
        color: #ffffff;
    }
}
</style>
